export default __webpack_public_path__ + "static/media/trend_up.3926c0e7.svg";